module.exports = __webpack_public_path__ + "media/images/logo-icon-b3577b76.png";